export default __webpack_public_path__ + "static/media/percentage-indicator-up.b591cff2.svg";